export default __webpack_public_path__ + "static/media/checkboxOn.895f02d9.svg";